// extracted by mini-css-extract-plugin
export default {"samplePage":"SamplePage_samplePage__sDYDo"};